"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Cascadecompared", {
  enumerable: true,
  get: function get() {
    return _cascadecompared["default"];
  }
});

var _cascadecompared = _interopRequireDefault(require("./cascadecompared"));

require("./index.less");